/* FloraBella advertorial: FAQ only. It deliberately does not modify images, sliders, or layout. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.gp-accordion-item_body').forEach(function (body) {
      if (body.dataset.florabellaFaq) return;
      /* The export marks question 1 as open. Reset every answer so all begin closed. */
      body.dataset.florabellaFaq = '1';
      body.dataset.florabellaOpen = '0';
      body.style.overflow = 'hidden';
      body.style.gridTemplateRows = '0fr';
      body.style.maxHeight = '0px';
      body.style.transition = 'max-height .35s ease, grid-template-rows .35s ease';
    });
  }
  function toggle(header) {
    var item = header.closest('.gp-accordion-item');
    var body = item && item.querySelector('.gp-accordion-item_body');
    if (!body) return;
    var isOpen = body.dataset.florabellaOpen === '1';
    if (isOpen) {
      body.style.maxHeight = body.scrollHeight + 'px';
      requestAnimationFrame(function () {
        body.style.maxHeight = '0px';
        body.style.gridTemplateRows = '0fr';
      });
      body.dataset.florabellaOpen = '0';
    } else {
      body.style.gridTemplateRows = '1fr';
      /* Answers differ greatly in length. A generous maximum lets the full answer
         render at every mobile width instead of clipping a long French response. */
      body.style.maxHeight = '5000px';
      body.dataset.florabellaOpen = '1';
    }
    header.classList.toggle('florabella-faq-open', !isOpen);
  }
  document.addEventListener('click', function (event) {
    var header = event.target.closest('.gp-accordion-item_header');
    if (!header) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    toggle(header);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
